import { IBodyApiUpdateStatusMultipleAppointment } from 'features/appointment/services/types/api';
import { AptDetailV3DataItem } from 'features/appointment/services/types/appointment';
import moment from 'moment';

export const REASON_PRESETS = ['Busy', 'Spam', 'Change time appointment'];

const TIME_PARSE_FORMATS = ['MM/DD/YYYY HH:mm', 'MM/DD/YYYY hh:mm A', moment.ISO_8601, 'hh:mm A', 'HH:mm'];

// Incoming time string format is not guaranteed; parse permissively and fall back to the raw value.
export const formatTime = (value?: string): string => {
  if (!value) return '';
  const parsed = moment(value, TIME_PARSE_FORMATS as moment.MomentFormatSpecification, false);
  return parsed.isValid() ? parsed.format('hh:mmA') : value;
};

export const formatTimeRange = (start?: string, end?: string): string =>
  [formatTime(start), formatTime(end)].filter(Boolean).join(' - ');

export const formatDate = (value?: string): string => {
  if (!value) return '';
  const parsed = moment(value, ['MM/DD/YYYY HH:mm', 'MM/DD/YYYY', moment.ISO_8601], false);
  return parsed.isValid() ? parsed.format('MM/DD/YYYY') : value;
};

// Map selected item indexes to a deduped set of appointmentId for the status-update API body.
// Status-agnostic: callers pass the target APPOINTMENT_STATUS (DELETE, CONFIRM, ...).
export const buildStatusBody = (
  items: AptDetailV3DataItem[],
  selectedKeys: Set<number>,
  status: number,
  reason = '',
): IBodyApiUpdateStatusMultipleAppointment => {
  const ids = Array.from(selectedKeys)
    .map((index) => items[index]?.appointmentId)
    .filter((id): id is string => Boolean(id));
  return {
    appointmentIds: Array.from(new Set(ids)),
    status,
    reason,
    createdBy: '',
  };
};
